// extracted by mini-css-extract-plugin
module.exports = {"results":"SearchInputPredict_results__vWouw","item-wrapper":"SearchInputPredict_item-wrapper__O9iR_","item-result":"SearchInputPredict_item-result__zpebL"};